import xhrService from '../xhrService';

const offlineApi = {
  
  download: (projectId,inspectionTemplateId) => {
    return xhrService.post(`/api/offline/`, { projectId, inspectionTemplateId })
    .then(response => response.data)
    .catch(({ response }) => {
      throw new Error(response.data.message);
    });
  },

  delete: (projectId) => {
    return xhrService.delete(`/api/offline/${projectId}`)
    .then(response => response.data)
    .catch(({ response }) => {
      throw new Error(response.data.message);
    });
  },
  getOfflineByUser: (userId) => {
    return xhrService.get(`/api/offline/user/${userId}`)
      .then(response => response.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  }

};

export default offlineApi;
export { offlineApi };
